import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Form, 
  FormInstance, Modal, Popconfirm, Avatar, Space, Empty, Select, Breadcrumb, 
  Menu, Dropdown, Cascader, TreeSelect, Tooltip,
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import { RootStoreModel } from "../../redux/reducers";
import { Unsubscribe } from "redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
// import { Columns } from "./utils";
import { ColumnModel, BasicStateForListModel } from "../models";
import { RemoveInvalidProps } from "../../utils/common";
import dayjs from 'dayjs';

import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import {
  getApps,
  addAndroidApp,
  updateAndroidApp,
  deleteAndroidApp,
  pushInstallApp,
  updateAppStatus,
  pushIosInstallApp,
  companyStoreGroup,
  getCompanyStoreGroup,
  getAppIntallDetail,
  appStrategy
} from "../../axios/api.app";
import { AppForm } from "./app.add";
import { PushAppForm } from "./app.push";
import { getTagList } from "@axios/api.account"
import { TagProps } from "@axios/models"
import { CloudUploadOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { gaEvent } from "../../withTracker"

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  pushAppInfo: object,
  appFormRef: FormInstance<any> | null,
  isDeviceModalvisible: boolean,
  isPushModalvisible: boolean,
  search: string,
  searchPlatform: string | undefined,
  selectAppId: string,
  appShowStatus: number,
  selectData: object,
  appTypeVisible: boolean,
  applyPeople: string,
  tags: any[],
  tableColumns: any[],
  // installDeviceCount: any,
  strategyModalVisible: boolean,
  autoUpgrade: string
}

interface propsModel extends RouteComponentProps<any, any, any> {
  tokenSuccess: boolean,
  orgOptions: treeNode[]
}
const mapStatetoProps = (state: RootStoreModel) => ({
  tokenSuccess: state.userState.tokenSuccess,
  orgOptions: getOrgsOptionsSelector(state),
});
class CompanyStorePage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      appFormRef: React.createRef<FormInstance>().current,
      isDeviceModalvisible: false,
      isPushModalvisible: false,
      search: "",
      searchPlatform: undefined,
      selectAppId: "",
      appShowStatus: 0,
      pushAppInfo: {},
      selectData: {},
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      tableColumns: [],
      // installDeviceCount: {},
      strategyModalVisible: false,
      autoUpgrade: "0"
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    if (this.props.tokenSuccess) {
      this.getList();
      this.getTasks();
    }
    this.setState({
      tableColumns: [
        {
          title: '',
          dataIndex: 'logoUrl',
          key: 'logoUrl',
          align: 'center',
          render: (v:any) => (
            <Avatar
              shape="square"
              size={68}
              src={v}
              alt=""
            />
          )
        },
        {
          title: '应用名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '包名',
          dataIndex: 'packageName',
          key: 'packageName',
        },
        {
          title: '平台',
          dataIndex: 'platform',
          key: 'platform',
          render: (v: any) => {
            return v === "IOS" ? "iOS" : v;
          }
        },
        {
          title: '安装设备',
          dataIndex: 'deviceCount',
          key: 'deviceCount',
          filterDropdown: true,
          filterIcon: (
            <Tooltip title={<Translation>{t => t("显示已安装此应用的设备，包含通过MDM安装和用户自行安装的")}</Translation>}>
              <QuestionCircleOutlined />
            </Tooltip>
          ),
          render: (v: any, row: any) => {
            return (
              <NavLink to={{ 
                pathname: `/home/apps/installDetail`, 
                state: { 
                  "isDevice": true,
                  "isAppStore": false,
                  "platform": row.platform, 
                  "packageName": row.packageName, 
                  "logoUrl": row.logoUrl, 
                  "name": row.name, 
                  "versionNumber": row.versionNumber, 
                  "appSize": row.appSize 
                } 
              }}>{v}</NavLink>
            )
          }
        },
        {
          title: '安装明细',
          dataIndex: 'installCount',
          key: 'installCount',
          filterDropdown: true,
          filterIcon: (
            <Tooltip title={<Translation>{t => t("显示通过MDM成功触发安装应用指令的设备具体状态，仅支持iOS16以上并开启声明式管理的设备并且操作InstallApp成功")}</Translation>}>
              <QuestionCircleOutlined />
            </Tooltip>
          ),
          render: (v: any, row: any) => {
            return (
              <NavLink to={{ 
                pathname: `/home/apps/installDetail`, 
                state: { 
                  "isDevice": false,
                  "isAppStore": false,
                  "platform": row.platform, 
                  "packageName": row.packageName, 
                  "logoUrl": row.logoUrl, 
                  "name": row.name, 
                  "versionNumber": row.versionNumber, 
                  "appSize": row.appSize,
                  "id": row.appId  
                } 
              }}>{`${row.installSuccessCount} / ${v}`}</NavLink>
            )
          }
        },
        {
          title: '更新日期',
          dataIndex: 'updatedTime',
          key: 'updatedTime',
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: '操作',
          dataIndex: 'appId',
          key: 'appId',
          align: 'center',
          render: (v: any, row: any) => {
            return (
              <Translation>{t => {
                return (
                  <Dropdown dropdownRender={() => (
                    <Menu>
                      <Menu.Item key="strategy">
                        <a className="ft-15" onClick={() => {
                          this.setState({ 
                            strategyModalVisible: true, 
                            selectAppId: row.appId
                          });
                          this.setState({autoUpgrade: row.autoUpgrade ? "1" : "0"})
                          // this.formRef.current?.setFieldsValue({autoUpgrade: row.autoUpgrade ? "1" : "0"});
                          gaEvent("appStore", "onClick", "应用策略");
                        }}>
                          {t("应用策略")}
                        </a>  
                      </Menu.Item>
                      <Menu.Item key="send" >
                        <a className="ft-15" onClick={() => this.setState({ isPushModalvisible: true, selectAppId: row.appId })}>{t("推送")}</a>  
                      </Menu.Item>
                      {/* <Menu.Item key="install">
                        <NavLink to={{ 
                          pathname: `/home/apps/installDetail`, 
                          state: { 
                            "isDevice": false,
                            "isAppStore": false,
                            "platform": row.platform, 
                            "packageName": row.packageName, 
                            "logoUrl": row.logoUrl, 
                            "name": row.name, 
                            "versionNumber": row.versionNumber, 
                            "appSize": row.appSize,
                            "id": row.appId  
                          } 
                        }}>{t("安装明细")}</NavLink></Menu.Item> */}
                      {/* 弃用——企业应用——历史版本 */}
                      {/* <Menu.Item key="history" hidden={!row.isHasHistoryVersion} ><NavLink to={`/home/apphistory/${row.appId}`}>{t("历史版本")}</NavLink></Menu.Item> */}
                      <Menu.Item key="update" onClick={() => {
                        this.setState({ isDeviceModalvisible: true, selectAppId: row.appId, appShowStatus: 1 })
                        console.log(" this.state.appFormRef", this.state.appFormRef, row)
                        this.setState({
                          selectData: {
                            "name": row.name,
                            "logoUrl": row.logoUrl,
                            "description": row.description,
                            "status": row.status,
                            packageName: row.packageName,
                            versionCode: row.versionCode,
                            version: row.versionNumber,
                            logoFileType: row.logoFileType, 
                            packageFileType: row.packageFileType, 
                            packageUrl: row.appStorageUrl, 
                          }
                        })
                      }}>{t("更新应用")}</Menu.Item>
                      {/* <Menu.Item key="add" onClick={() => {
                        this.setState({ isDeviceModalvisible: true, selectAppId: row.appId, appShowStatus: 0 });
                        gaEvent("companyStore", "onClick", "上传新版本");
                      }}>{t("上传新版本")}</Menu.Item> */}
                      <Menu.Item key="service" onClick={() => { this.getAppSelfService(row.appId) }}>{t("自助服务")}</Menu.Item>
                      <Menu.Item key="status" onClick={() => {
                        this.updateAppStatusClick(row.appId, row.status);
                        gaEvent("companyStore", "onClick", "禁用");
                      }}>{row.status == "Active" ? t("禁用") : t("启用")}</Menu.Item>
                    </Menu>
                  )}><a>{t("更多")}</a>
                  </Dropdown>
                )
              }}</Translation>
            );
          }
        },
      ]
    })
  }

  // getAppInstallInfo = (dataList: any) => {
  //   const tmp: any = {};
  //   dataList.forEach((item: any) => {
  //     getAppIntallDetail(item.appId, {
  //       pageIndex: 1,
  //       pageSize: 10,
  //       searchName: ""
  //     }).then((res) => {
  //       tmp[item.appId] = res.totalCount;
  //       this.setState({installDeviceCount: {...tmp}});
  //     });
  //   })
  // }

  getTasks = () => {
    getTagList().then((res) => {
      var dat = this.formatOptions(res)
      console.log("formatOptions", dat);
      this.setState({ tags: dat })
    })
  }

  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }

  componentDidUpdate(prevProps: propsModel) {
    if (this.props.tokenSuccess != prevProps.tokenSuccess) {
      this.getList(1);
      this.getTasks(); 
    }
  }
  componentWillUnmount() {
    // this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getList(1);
  };
  updateAppStatusClick = (appId: string, status: string) => {

    this.setState({ loading: true });
    updateAppStatus(appId, status == "Active" ? "Disabled" : "Active").then((res) => {
      this.setState({ loading: false })
      this.getList();
    });
  };
  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search, searchPlatform } = this.state;
    this.setState({ loading: true });
    getApps({
      pageIndex,
      pageSize,
      searchName: search,
      platform: searchPlatform,
    }).then((res) => {
      const { dataList } = res;
      this.setState({
        data: dataList.map((item, i) => ({ ...item, key: i })),
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        loading: false,
        totalCount: res.totalCount,
      });
      // this.getAppInstallInfo(dataList);
    });
  };

  onOk = () => {
    this.state.appFormRef?.validateFields().then(
      (res) => {
        const { name, status, description, logo, appPackage, packageName, 
          versionCode, version,logoFileType, logoUrl,packageFileType, packageUrl
        } = res;
        console.log(res);
        this.setState({ loading: true });
        if (this.state.appShowStatus == 0) {
          if (packageFileType == 'Upload' && !appPackage[0]?.response?.objectID) {
            notification.error({ message: <Translation>{t => {return t("请先上传apk")}}</Translation> })
            return;
          }
          addAndroidApp({
            name,
            description,
            status,
            logo: logo ? (logo[0]?.originFileObj) : "",
            appTempId: appPackage ? appPackage[0]?.response?.objectID : "",
            packageName, 
            versionCode, 
            version,
            logoFileType, 
            logoUrl,
            packageFileType, 
            packageUrl
          }).then(
            () => {
              notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
              this.setState(
                () => {
                  this.state.appFormRef?.resetFields();
                }
              );
              this.getList(1);
            },
            () => { notification.error({message: <Translation>{t => {return t("添加失败")}}</Translation>}) }
          ).finally(() => {
            this.setState({ loading: false, isDeviceModalvisible: false })
          })
        } else if (this.state.appShowStatus == 1) {
          console.log("this.state.selectAppId", this.state.selectAppId)
          updateAndroidApp(this.state.selectAppId, {
            name,
            description,
            status,
            logo: logo ? (logo[0]?.originFileObj) : "",
            appTempId: appPackage ? appPackage[0]?.response?.objectID : "",
            packageName, 
            versionCode, 
            version,
            logoFileType, 
            logoUrl,
            packageFileType, 
            packageUrl
          }).then(
            () => {
              notification.success({ message: <Translation>{t => {return t("更新成功")}}</Translation> });
              this.getList(1);
              this.state.appFormRef?.resetFields();
            },
            () => { notification.error({message: <Translation>{t => {return t("更新失败")}}</Translation>}) }
          ).finally(() => {
            this.setState({ loading: false, isDeviceModalvisible: false })
          })
        }
      }
    );
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteAndroidApp(id).then(
      () => {
        notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
        this.setState({ loading: false });
        this.getList(1);
      },
      () => this.setState({ loading: false })
    );
  };
  applyGroupOk = () => {
    this.setState({ loading: true })
    this.formRef?.current?.validateFields().then((res) => {
      // if (!res.type) {
      //   this.setState({loading: false})
      //   return notification.warning({message: "未选择适用人群"})
      // }
      var arg: any = {pushType: res.type || 'None'};
      // if (this.state.applyPeople == "Organization") {
      //   arg.organizationIds = [];
      //   arg.organizationIds.push(res.Organization);
      // }
      if (this.state.applyPeople == "Tag") {
        arg.tagValueIds = [];
        res.tags.forEach((item: any) => {
          arg.tagValueIds.push(item.tag[1]);
        });
      }
      companyStoreGroup(this.state.selectAppId, arg).then(c => {
        notification.success({ message: <Translation>{t => {return t("成功")}}</Translation> })
        this.setState({ loading: false, appTypeVisible: false, applyPeople: "" })
      }, () => {
        this.setState({ loading: false })
        notification.error({ message: <Translation>{t => {return t("失败")}}</Translation> })
      })

    })

  }

  getAppSelfService = (id: string) => {
    this.setState({loading: true});
    getCompanyStoreGroup(id).then(
      res => {
        // 先渲染出模态框
        this.setState({ appTypeVisible: true, selectAppId: id, applyPeople: res.pushType });
        // 再更新formRef
        this.formRef.current?.setFieldsValue({
          type: res.pushType,
          Organization: res.organizationIds[0],
          tags: res.tags
        });
      },
      () => {
        notification.error({message: <Translation>{t => {return t("获取自助服务失败")}}</Translation>});
      }
    ).finally(
      () => {
        this.setState({loading: false});
      }
    )
  }

  onStrategyOk = () => {
    this.formRef.current?.validateFields().then((res) => {
      var form = {
        "autoUpgrade": res.autoUpgrade === "1" ? true : false
      }
      appStrategy(this.state.selectAppId, form).then(() => {
        notification.success({message: <Translation>{t => {return t("操作成功")}}</Translation>});
        this.formRef.current?.resetFields();
        this.setState({strategyModalVisible: false, selectAppId: ""});
        this.getList();
      }).finally(() => {
        this.setState({loading: false})
      })
    })
    
  }
  
  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isDeviceModalvisible,
      isPushModalvisible,
      search,
      searchPlatform,
      selectAppId,
      appShowStatus,
      appTypeVisible,
      applyPeople,
      tags,
      tableColumns,
      strategyModalVisible,
      autoUpgrade
    } = this.state;
    const { orgOptions } = this.props;
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("应用库")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("企业应用")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/companyappIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("企业应用")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={loading}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3" gutter={20}>
                      <Col>
                        {t("应用名称")}:
                        <Input
                          placeholder={t("输入应用名称")}
                          value={search}
                          style={{ width: "220px", marginLeft: 10 }}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>
                      <Col>
                        {t("平台")}:
                        <Select
                          value={searchPlatform}
                          style={{ width: "200px", marginLeft: 10 }}
                          onChange={(v) => this.setState({ searchPlatform: v })}
                          allowClear
                          placeholder={t("全部平台")}
                        >
                          <Select.Option value="0">{t("全部平台")}</Select.Option>
                          <Select.Option value="IOS">iOS</Select.Option>
                          <Select.Option value="Android">Android</Select.Option>
                          <Select.Option value="macOS">macOS</Select.Option>
                          <Select.Option value="Windows">Windows</Select.Option>
                        </Select>
                      </Col>
                      <Col>
                        <Button type="primary" onClick={this.onSearch}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row>
                      <Col className="ms-auto" style={{ marginBottom: 8 }}>
                        <Button
                          type="primary"
                          onClick={() => {
                            this.setState({ isDeviceModalvisible: true, appShowStatus: 0 });
                            gaEvent("companyStore", "onClick", "上传App");
                          }}
                        >
                          {t("添加应用")}
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      {data.length > 0 && (
                        <Table
                          size="middle"
                          style={{width: "100%"}}
                          loading={loading}
                          dataSource={data}
                          pagination={false}
                          // onChange={this.onTableChange}
                          rowKey={record => record.id}
                          columns={tableColumns.map((item)=>{ 
                            item.title = t(item.title)
                            return item 
                          })}
                          // rowSelection={this.rowSelection()}
                          locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        ></Table>
                      )}
                      {/* {data.map(
                        (
                          {
                            name,
                            versionNumber,
                            accountOid,
                            appSize,
                            appId,
                            description,
                            logoUrl,
                            appStorageUrl,
                            status,
                            isHasHistoryVersion,
                            packageName,
                            versionCode,
                            platform
                          },
                          i
                        ) => (
                          <Col key={i} className="py-1">
                            <div
                              className="shadow text-center"
                              style={{ width: "308px", paddingTop: 32 }}
                            >
                              <div className="text-center">
                                <Avatar
                                  shape="square"
                                  size={68}
                                  // className="shadow-sm"
                                  src={logoUrl}
                                  alt=""
                                />
                              </div>
                              <div
                                className="mt-3"
                                style={{ height: "80px", overflow: "hidden" }}>
                                <div>
                                  <strong>{name}</strong>
                                </div>
                                <div className="text-muted">
                                  <small>平台:{platform === "IOS" ? "iOS" : platform}</small>
                                </div>
                                <small className="text-muted">{description}</small>
                              </div>
                              <div className="ft-14 text-secondary mt-3">
                                版本：v{versionNumber}
                              </div>
                              <div className="ft-14 text-secondary">
                                大小：{appSize}
                              </div>
                              <div className="mt-5 text-center">
                                <Row className="boderTop">
                                  <Col span={12} className="boderLeft" style={{ padding: 14 }}>
                                    <a className="ft-15" onClick={() => this.setState({ isPushModalvisible: true, selectAppId: appId })}>推送</a>
                                  </Col>
                                  <Col  span={12} style={{ padding: 14 }}>
                                    <Dropdown overlay={
                                      <Menu>
                                        <Menu.Item key="install" ><NavLink to={{ pathname: `/home/apps/installDetail`, state: { "platform": "android", "searchId": appId, "logoUrl": logoUrl, "name": name, "versionNumber": versionNumber, "appSize": appSize } }}>安装明细</NavLink></Menu.Item>
                                        <Menu.Item key="history" hidden={!isHasHistoryVersion} ><NavLink to={`/home/apphistory/${appId}`}>历史版本</NavLink></Menu.Item>
                                        <Menu.Item key="update" onClick={() => {
                                          gaEvent("companyStore", "onClick", "更新应用信息");
                                          this.setState({ isDeviceModalvisible: true, selectAppId: appId, appShowStatus: 1 })
                                          console.log(" this.state.appFormRef", this.state.appFormRef)
                                          this.setState({
                                            selectData: {
                                              "name": name,
                                              "logoUrl": logoUrl,
                                              "description": description,
                                              "status": status,
                                              packageName: packageName,
                                              versionCode: versionCode,
                                              version: versionNumber
                                            }
                                          })
                                        }}>更新应用信息</Menu.Item>
                                        <Menu.Item key="add" onClick={() => {
                                          this.setState({ isDeviceModalvisible: true, selectAppId: appId, appShowStatus: 0 });
                                          gaEvent("companyStore", "onClick", "上传新版本");
                                        }}>上传新版本</Menu.Item>
                                        <Menu.Item key="service" onClick={() => { this.getAppSelfService(appId) }}>自助服务</Menu.Item>
                                        <Menu.Item key="status" onClick={() => {
                                          this.updateAppStatusClick(appId, status);
                                          gaEvent("companyStore", "onClick", "禁用");
                                        }}>{status == "Active" ? "禁用" : "启用"}</Menu.Item>
                                      </Menu>
                                    }><a>更多</a>
                                    </Dropdown>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Col>
                        )
                      )} */}
                    </Row>
                    {data.length <= 0 && (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>
                    )}
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={isDeviceModalvisible}
                destroyOnClose={true}
                title={appShowStatus == 0 ? t("添加应用") : t("更新App")}
                width={"650px"}
                onOk={() => this.onOk()}
                onCancel={() => {
                  this.setState({ isDeviceModalvisible: false, loading: false });
                  this.state.appFormRef?.resetFields();

                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <AppForm
                  status={appShowStatus ? appShowStatus : 0} onLoad={(ref) => {
                    this.setState({ appFormRef: ref })
                    if (appShowStatus == 1) {
                      ref.setFieldsValue(this.state.selectData);
                    }
                  }}
                ></AppForm>
              </Modal>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={isPushModalvisible}
                destroyOnClose={true}
                title={t("推送应用")}
                width={"650px"}
                onOk={() => {
                  console.log(this.state.pushAppInfo)
                  this.setState({ loading: true });
                  pushInstallApp(selectAppId, this.state.pushAppInfo).then(
                    () => {
                      notification.success({ message: t("推送成功") });
                      this.setState(
                        { loading: false, isPushModalvisible: false },
                        () => {
                          this.state.appFormRef?.resetFields();
                        }
                      );
                    },
                    () => this.setState({ loading: false })
                  );
                }}
                onCancel={() => {
                  this.setState({ isPushModalvisible: false, loading: false });
                  this.setState({ pushAppInfo: {} })
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <PushAppForm
                  appId={selectAppId}
                  onLoad={(ref) => {
                    console.log(ref)
                    this.setState({ pushAppInfo: ref })
                  }}
                ></PushAppForm>
              </Modal>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={appTypeVisible}
                destroyOnClose={false}
                title={t("自助服务")}
                width={"650px"}
                onOk={() => {
                  this.applyGroupOk()
                }}
                onCancel={() => {
                  this.setState({ appTypeVisible: false, applyPeople: "" })
                  this.formRef.current?.resetFields()
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form style={{ width: "90%", marginTop: 36 }}
                  layout="horizontal"
                  ref={this.formRef}
                  // labelCol={{ span: 3 }}
                  initialValues={{ type: "None" }}
                >
                  {/* <Form.Item label="应用分类" name="status" rules={[{ required: false }]} >
                    <Select>
                      <Select.Option value="1">效率</Select.Option>
                    </Select>

                  </Form.Item> */}
                  <Form.Item label={t("适用人群")} name="type" rules={[{ required: false }]} >
                    <Select allowClear placeholder={t("未选择")} onChange={(e) => {
                      this.setState({ applyPeople: e + "" })
                      this.formRef.current?.setFieldsValue({
                        Organization: [],
                        tags: []
                      })
                    }}>
                      <Select.Option value="None">{t("未选择")}</Select.Option>
                      <Select.Option value="All">{t("全部")}</Select.Option>
                      {/* <Select.Option value="Organization">{t("部门")}</Select.Option> */}
                      <Select.Option value="Tag">{t("设备组")}</Select.Option>
                    </Select>
                  </Form.Item>
                  {/* {applyPeople == "Organization" && (
                    <Form.Item label={t("选择部门")} name="Organization" rules={[{ required: false }]} >
                      <TreeSelect treeData={orgOptions} treeDefaultExpandAll></TreeSelect>
                    </Form.Item>
                  )} */}
                  {applyPeople == "Tag" && (
                    <Form.List name="tags">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field) => (
                            <Form.Item key={field.key} labelCol={{ span: 3 }} label={t("设备组")}>
                              <Row justify="space-between">
                                <Col span="21">
                                  <Form.Item noStyle
                                    {...field}
                                    name={[field.name, "tag"]}
                                    // fieldKey={[field.fieldKey, "tag"]}
                                  >
                                    <Cascader options={tags} />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Button type="dashed" onClick={() => { remove(field.name); gaEvent("deviceAdd", "onClick", "remove") }}>-</Button>
                                </Col>
                              </Row>
                            </Form.Item>
                          ))}
                          <Form.Item wrapperCol={{ offset: 3 }}>
                            <Button type="dashed" onClick={() => { add(); gaEvent("deviceAdd", "onClick", "add") }} block>
                              {t("添加设备组")}
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  )}
                </Form>
              </Modal>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={strategyModalVisible}
                destroyOnClose={true}
                title={t("应用策略")}
                width={"650px"}
                onOk={() => { this.onStrategyOk() }}
                onCancel={() => {
                  this.setState({ 
                    strategyModalVisible: false, 
                    selectAppId: "",
                    autoUpgrade: "0"
                  });
                  this.formRef.current?.resetFields();
                }}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form 
                  style={{ width: "90%", marginTop: 36 }}
                  layout="horizontal"
                  ref={this.formRef}
                  initialValues={{"autoUpgrade": autoUpgrade}}
                >
                  {/* <Form.Item hidden label={t("更改为受管理应用")} name="changeManagedApp">
                    <Select>
                      <Select.Option value="1">{t("是")}</Select.Option>
                      <Select.Option value="0">{t("否")}</Select.Option>
                    </Select>
                  </Form.Item> */}
                  <Form.Item label={t("自动强制应用升级")} name="autoUpgrade">
                    <Select>
                      <Select.Option value="1">{t("是")}</Select.Option>
                      <Select.Option value="0">{t("否")}</Select.Option>
                    </Select>
                  </Form.Item>
                </Form>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}
export default connect(mapStatetoProps, {})(CompanyStorePage);
